import context from '@truckdown/systems';
import { email, required } from '@vuelidate/validators';
import { useVuelidate, Validation } from '@vuelidate/core';
import { defineComponent, ref, watch, Ref, onMounted, onUnmounted } from 'vue';

const phone = (value: string) => /^\+?(1|\d{3})?[-. ]?\(?(\d{3})\)?[-. ]?(\d{3})[-. ]?(\d{4})$/.test(value);

interface IData {
    name: Ref<string>,
    phone: Ref<string>,
    email: Ref<string>,
    captchaReturn: Ref<string>,
    upgradeForm: Ref<HTMLElement | null>
}

const validations = {
    name: {
        required,
        $autoDirty: true 
    },
    phone: {
        phone,
        $autoDirty: true 
    },
    email: {
        email,
        required,
        $autoDirty: true 
    },
    captchaReturn: {
        required
    }
};

const getData = function (props: any) {
    return {
        name: ref<string>(context.user?.firstName + ' ' + context.user?.lastName),
        phone: ref<string>(context.user?.phone ?? ''),
        email: ref<string>(context.user?.email ?? ''),
        upgradeForm: ref<HTMLElement | null>(null),
        captchaReturn: ref<string>('')
    } as IData;
}

const getMethods = function (props: any, data: IData, validator: Ref<Validation>) {
    let isSubmitting = false;

    const validate = function () {
        validator.value.$touch();
        return validator.value.$validate()
            .then((res) => {
                return res; // && hasCaptcha();
            });
    }

    return {
        returnToPrevious: function (ev: Event) {
            if (props.returnUrl && props.returnUrl.startsWith('/')) {
                window.location.href = props.returnUrl;
            }
            window.history.back();
        },
        submitForm: function (e: Event) {
            if (!isSubmitting) {
                isSubmitting = true;
                validate()
                    .then((res) => {
                        if (res) {
                            (data.upgradeForm.value as HTMLFormElement).submit();
                        } else {
                            isSubmitting = false;
                        }
                    });
            }
        }
    }
}


export default defineComponent({
    props: {
        returnUrl: String,
        error: String
    },
    emits: ['update:modelValue', 'validated'],
    setup: function (props, ctx: any) {
        const data = getData(props);
        const v$ = useVuelidate(validations, data);

        const methods = getMethods(props, data, v$);

        const setCaptcha = function (instance: string, response: string) {
            if (instance == 'fleet-upgrade') {
                data.captchaReturn.value = response;
            }
        }

        onMounted(() => {
            context.events.on('captcha-response', setCaptcha);
        });

        onUnmounted(() => {
            context.events.off('captcha-response', setCaptcha);
        });

        return {
            ...data,
            ...methods,
            v$,
            'context': context
        };
    }
});
